<template>
    <v-container grid-list-md>
        <v-layout align-start justify-start row>
            <v-flex xs12 sm12 md4>
                <v-layout align-start justify-start row>
                    <v-flex xs1 sm1 md2>
                        <v-btn fab dark color="primary" @click="addClient">
                            <v-icon color="secondary">add</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs11 sm11 md10 class="ml-4">
                        <v-autocomplete
                                v-model="selected_client"
                                :items="select_clients"
                                label="Select client"
                                item-text="name"
                                item-value="id"
                        >
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-title>
            Assigned Clients
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="clients.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td class="text-xs" ><v-btn :to="{ name: 'admin.clients.detail', params : { id : props.item.id } }" flat small>{{ props.item.email }}</v-btn></td>
                <td class="text-xs">{{ props.item.company_name }}</td>
                <td class="text-xs">{{ props.item.country }}</td>
                <td class="text-xs">{{ props.item.state }}</td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="clients.data">
            <v-pagination
                    v-model="page"
                    :length="clients.meta.last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
                    @input="setPage"
            ></v-pagination>
            <p class="subtitle">Showing {{ clients.meta.from }} to {{ clients.meta.to }} of {{ clients.meta.total }} entries</p>
        </div>
    </v-container>
</template>

<script>
    export default {
        props: ['id'],
        data () {
            return {
                selected_client: null,
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    { text: 'Email', value: 'email', sortable: false },
                    { text: 'Company name', value: 'company', sortable: false },
                    { text: 'Country', value: 'country', sortable: false },
                    { text: 'State', value: 'state', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                clients: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                select_clients: null
            }
        },
        created () {
            this.getClientsList();
            this.getClientsSelect();
            this.debouncedGetClients = _.debounce(this.getClientsList, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetClients();
            },
            last_page: function () {
                if (this.page > this.clients.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods: {
            deleteItem (client_id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteClientAgent', {
                            id: this.id,
                            client_id: client_id
                        }).then((res) => {

                            this.$store.dispatch('setSnackBarText', {
                                text: 'Client deleted successfully.'
                            });
                            this.$store.dispatch('activeSnack')

                            this.getClientsList();
                            this.getClientsSelect();

                        }).catch((error) => {

                        });
                    }
                })
            },
            addClient () {
                this.$store.dispatch('addClientAgent', {
                    id: this.id,
                    client_id: this.selected_client
                }).then((res) => {

                    this.$store.dispatch('setSnackBarText', {
                        text: 'Client asigned successfully.'
                    });
                    this.$store.dispatch('activeSnack')

                    this.selected_client = null;
                    this.getClientsList();
                    this.getClientsSelect();


                }).catch((error) => {

                });
            },
            getClientsSelect () {
                this.$store.dispatch('getClientsAgentSelect', {
                    id: this.id
                }).then((res) => {

                    this.select_clients = res.data;

                }).catch((error) => {

                });
            },
            getClientsList () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page
                    }
                };
                this.$store.dispatch('getClientsAgent', {
                    id: this.id,
                    params: params
                }).then((res) => {

                    this.clients = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            setPage (page) {
                this.page = page;
                this.getClients();
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/agents/view/ClientsComponent.vue